import {
  AppointmentGuideDTO,
  ResultApiLegacy,
} from 'features/tissInvoicing/types';

export function createAppointmentGuideListFromApiLegacyDTO(
  resultsDTO: ResultApiLegacy[],
): AppointmentGuideDTO[] {
  const appointmentGuideList: AppointmentGuideDTO[] = resultsDTO.map((r) => ({
    id: `${r.id}`,
    appointmentDate: r.appointment_date,
    billedIn: r.billed_in || '--',
    completed: r.completed,
    insuranceName: r.insurance_name,
    patientName: r.patient_name,
    version: r.version,
    api: 'legacy',
  }));

  return appointmentGuideList;
}
